import formValidator, { required } from "@insightfulscience/shared-utils/validation";

const schema = {
	seats: [
		[required, "errors.SEATS_REQUIRED"],
		[
			(value, { minSeats, maxSeats }) => value >= minSeats && value <= maxSeats,
			"errors.WRONG_SEATS",
		],
	],
};

export const validateForm = formValidator(schema);
